import { FC } from "react";
import { Box, Grid, Heading, Spinner, Text } from "@radix-ui/themes";
import { useNewsBySlugs } from "@/features/news/hooks/useNewsBySlugs";
import SingleNewsCard from "@/features/news/components/overview/SingleNewsCard";
import { ErrorFallback } from "@/components";
import { siteRoutes } from "@/routes/siteRoutesList";

interface SingleEventNewsProps {
  news: string[];
}

export const SingleEventNews: FC<SingleEventNewsProps> = ({
  news,
}): JSX.Element => {
  const { data: relatedNews, loading, error } = useNewsBySlugs(news);

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorFallback>Failed to load news</ErrorFallback>;
  }

  return (
    <Box>
      <Heading as="h2" size="4" mb="2">
        News
      </Heading>
      <Grid columns={{ initial: "1", lg: "3" }} gap="5">
        {relatedNews.length > 0 ? (
          relatedNews.map((item, index) => {
            const slug = `${siteRoutes["zone"]}${item.zone}${siteRoutes["newsAndSlug"]}${item.slug}`;

            return (
              <SingleNewsCard
                key={index}
                slug={slug}
                title={item.title}
                imageURL={item.imageURL}
                isFeatured={item.isFeatured}
                author={item.author}
                created={item.created}
                isFavoriteByCurrentUser={false}
                intro={item.intro}
                keywords={[]}
                zone={item.zone}
              />
            );
          })
        ) : (
          <Text>No news found.</Text>
        )}
      </Grid>
    </Box>
  );
};
